'use strict';

import React from 'react';

require('styles//Stats.css');
let dividepercent = require('../images/dividepercent.png');
let year = require('../images/year.png');
//let low = require('../images/low.png');

class StatsComponent extends React.Component {
  render() {
    return (
      <div className="stats-component">
         <h3 className="h3">Медицинская статистика</h3>
        <ul className="list1">
        <li><img src={dividepercent} alt="" />
		  	<h4>Медицинские информационные системы</h4>
            <p className="zoom">"Медстат", "Мединфо", "Национальный регистр больных туберкулезом", "Воспалительные заболевания кишечника", "Регистр наркологических больных"
            , "Регистр больных с психическими расстройствами", "Национальный регистр больных сахарным диабетом", "Регистр больных с хронической почечной недостаточностью"</p>
            <a href="https://minzdrav.kz" className="link1"><em><b>Подробнее<span>Подробнее</span></b></em></a></li>
        <li><img src={dividepercent} alt="" />
		  	<h4>Портал "Медстат". Заполнение статистических форм.</h4>
            <p className="zoom">Портал "Медстат". Заполнение статистических форм.</p>
            <a href="https://medstat.minzdrav.kz/license" className="link1"><em><b>Подробнее<span>Подробнее</span></b></em></a></li>
          <li><img src={dividepercent} alt="" />
		  	<h4>Медико-демографические показатели в разрезе областей Республики Казахстан с 1990 года по настоящее время</h4>
            <p className="zoom">Медико-демографические показатели в разрезе областей Республики Казахстан с 1990 года по настоящее время</p>
            <a href="#/dpsobl" className="link1"><em><b>Подробнее<span>Подробнее</span></b></em></a></li>
          <li><img src={year} alt="" />
		  	<h4>Медико-демографические показатели в разрезе районов Республики Казахстан с 2000 года по настоящее время</h4>
            <p className="zoom">Медико-демографические показатели в разрезе районов Республики Казахстан с 2000 года по настоящее время</p>
            <a href="#/dpsraion" className="link1"><em><b>Подробнее<span>Подробнее</span></b></em></a> </li>
        </ul>
      </div>
    );
  }
}

StatsComponent.displayName = 'StatsComponent';

/*
  <li><img src={low} alt="" />
		    <h4>Оперативные данные по материнской и детской смертности</h4>
            <p className="zoom">Оперативные данные по материнской и детской смертности</p>
            <a href="#/mother" className="link1"><em><b>Подробнее<span>Подробнее</span></b></em></a> </li>
*/
// Uncomment properties you need
// StatsComponent.propTypes = {};
// StatsComponent.defaultProps = {};

export default StatsComponent;



// WEBPACK FOOTER //
// ./src/components/StatsComponent.js